import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
//import { AngularFirestoreCollection } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireFunctions } from '@angular/fire/functions'
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../environments/environment';
import { User } from '../interfaces/user';
import { ModalTextComponent } from '../modals/modal-text/modal-text.component';
import { ProgressbarmodalComponent } from '../modals/progressbarmodal/progressbarmodal.component';
import { GlobalService } from '../services/global.service';
import { PresenceService } from '../services/presence.service';
import { TranslationPipe } from '../shared/pipes/translation.pipe';



@Injectable({
  providedIn: 'root'
})

export class FirebaseService {


  user: User = { uid: null, role: null, email: null, createdAt: null };
  devices: any = [];
  selectedDeviceFirebaseService: any;
  selectedDevices: any = [];
  userCollection: AngularFirestoreCollection = this.afs.collection('users')

  userSub: Subscription = null;
  devicesSub: Subscription = null;
  urlSub: Subscription = null;
  adminFirebaseUrl: string = 'https://user.digitalbroker.io'


  uploadPercent: Observable<number>;
  downloadURL: Observable<string>;

  userCheck = new BehaviorSubject<any>(this.user);
  dataModuleValues = new Subject<any>();


  quizModule = new BehaviorSubject<any>(null);
  questionsData = new BehaviorSubject<any>(null);
  public globalActiveModule: Subject<any> = new Subject<any>();

  mediaModuleSnapshot = new BehaviorSubject<any>(null);
  moduleSnapshot: any;

  selectedModuleData: any;
  dialogRef: any;
  /**
   *
   *Add auto connection
   *
   * @param afAuth Angular fire authentification module
   * @param afs Angular fire firestore module
   * @param router Router module
   * @param snackBar MatSnackBar module
   * @param http HttpClient module
   * @param storage Angular fire Firestorage module
   */

  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore,
    public translation: TranslationPipe, private router: Router,
    private snackBar: MatSnackBar, private http: HttpClient,
    private storage: AngularFireStorage,
    private afFunc: AngularFireFunctions,
    private global: GlobalService,
    private presence: PresenceService,
    public dialog: MatDialog) {



    this.afAuth.authState.subscribe((data) => {

      // console.log("CHECK AUTOLOG")
      if (data != null)
        this.userSub = this.getUserData(data.uid).subscribe((data) => {

          this.setLocalUser(data)
          this.getModuleActiveByUser(this.user.uid)
          this.snackBar.open(`👍 ${this.translation.transform('loggedInAs')} ${this.user.displayName}.`, 'OK', {
            duration: 5000
          })
          if (this.user.role == 'user' || this.user.role == 'mainuser' || this.user.role == 'subuser')
            this.router.navigate(['/home'])
          else if (this.user.role == 'admin')
            this.router.navigate(['/admin'])
        })

      else {
      }
    })





  }


  /**
  *
  * Update Media Filetree when update on kiosk
  *
  * @param d Firebase documents
  * @param config new config
  * @param device device name
  * @param group groupe name
  */
  forceUpdateFromKioskChange(d, config, device, group) {



    let elements = d.docs.map(v => { return { 'data': v.data(), 'id': v.id } })

    if (config.filename == undefined)
      config.filename = "";
    elements.forEach(item => {
      this.afs.collection('media').doc(item.id).update({ thumbnailUrl: config.thumbnailUrl, url: config.url, name: config.name, filename: config.filename }).then(() => {
        // this.updateModule(moduleId, { latestUpdate: new Date() })

        //  this._firebase.updateConfigModule({ fileTree: tmp }, this.moduleId)


        this.afs.collection('modules').ref.where('type', '==', "media").where('parent', '==', this.user.uid).where('device', '==', device).where('group', '==', group).get().then(d => {
          let id = d.docs.map(v => v.id);
          let data = d.docs.map(v => v.data()) as any;

          let localFileTree = data[0].fileTree;
          let loopThrough = (e) => {
            if (this.isIterable(e))
              for (let elem of e) {
                if (elem.id == item.id) {
                  elem.name = config.name;
                  elem.thumbnailName = config.filename
                  elem.thumbnail = config.thumbnailUrl
                  //elem.thumbnail = config.thumbnail;
                  // elem.thumbnailName = config.
                  // delete elem.mediaOptions;
                }

                else if (elem.children != undefined && elem.children.length > 0)
                  loopThrough(elem.children)
              }
          }
          loopThrough(localFileTree)


          this.afs.collection('modules').doc(id[0]).update({ latestUpdate: new Date(), fileTree: localFileTree })

        })
      });

    })
  }

  changeWebviewMediaModule(oldConfig,/*, moduleId*/device, group, config) {



    this.afs.collection("media").ref.where('type', '==', 'web').where('id', '==', oldConfig.id).get().then(d => {
      this.forceUpdateFromKioskChange(d, config, device, group)
      let elements = d.docs.map(v => v.data())
      //  if (elements.length == 0) {

      /* this.afs.collection("media").ref.where('type', '==', 'web').where('name', '==', oldConfig.name).get().then(f => {
         // this.forceUpdateFromKioskChange(d, config, device, group)
       })*/
      //   }
    }).catch(err => {
      console.log("ERR", err)
    })
    /* */
  }

  changeQuizMediaModule(id, data) {
    this.afs.collection("media").ref.where('type', '==', "quiz").where("idQuiz", '==', id).get().then(d => {
      let ids = d.docs.map(v => v.id)

      ids.forEach((item) => {
        this.afs.collection('media').doc(item).update(data)
      })

      this.renameElementInFileTree('quiz', data.name, id);

      //this.updateModule(moduleId, { latestUpdate: new Date() })

    })
  }

  renameElementInFileTree(type, name, id) {
    this.afs.collection('modules').ref.where('type', '==', 'media').where('parent', '==', this.user.uid).get().then(d => {
      let data = d.docs.map(v => v.data())[0] as any;

      let idModule = d.docs.map(v => v.id);


      let loopThrough = (e) => {
        if (this.isIterable(e))
          for (let item of e) {

            if (item.type == type) {
              if (id == item.idQuiz) {
                item.name = name
              }
            }

            else if (item.children != undefined && item.children.length > 0)
              loopThrough(item.children)
          }
      }
      loopThrough(data.fileTree)

      this.afs.collection('modules').doc(idModule[0]).update({ fileTree: data.fileTree })

    })
  }


  /**
   * Remove image from firestorage
   *
   * @param url The firestorage's url of the image
   */
  removeImg(url, backupData = null) {

    if (backupData && backupData.urlImageBackUpArray.includes(url))
      return;
    this.checkIfTimeFileUsed(url).then(d => {
      if (d <= 1) {
        this.storage.storage.refFromURL(url).delete().then(d => {
        }).catch(err => {
          console.log("Error: ", err)
        });
      }

    })


  }


  /**
   * Return promise with all group collection
   * */
  getAllGroups() {
    return new Promise<any>((resolve, reject) => {

      this.afs.collection('groups').get().toPromise().then(d => {
        let res;
        res = d.docs.map(v => {

          let tmp = v.data()

          tmp.id = v.id;
          return tmp
        })

        console.log(res)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }

  checkIfUserExist(email) {
    return this.afAuth.auth.fetchSignInMethodsForEmail(email)
  }

  /**
   * Return group from id
   * @param id
   */
  getGroupsFromId(id) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('groups').doc(id).get().toPromise().then(d => {
        resolve([{ id: d.id, data: d.data() }])

      }).catch(err => reject(err));
    })
  }

  /**
   * Return promise with groups from User
   * */
  getAllGroupsFromUser() {

    return new Promise<any>((resolve, reject) => {
      console.log("GET ALL GROUPS FROM USER", this.user.role)
      if (this.user.role != 'subuser')
        this.afs.collection('groups').ref.where('parent', '==', this.user.uid).get().then(d => {



          resolve(d.docs.map(v => v.data()))
        }).catch(err => {
          reject(err)
        })
      else
        this.afs.collection('groups').ref.where('parent', '==', this.user.parentuid).get().then(d => {



          resolve(d.docs.map(v => v.data()))
        }).catch(err => {
          reject(err)
        })
    })
  }
  /**
   * Return promise with all devices
   *
   * */

  getAllDevices() {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('devices').get().toPromise().then(d => {
        resolve(d.docs.map(v => { return ({ id: v.id, data: v.data() }) }))
      }).catch(err => {
        reject(err)
      })
    })
  }

  /**
   * Return promise with devices from user
   * */

  getAllDevicesFromUser() {
    console.log(this.user)
    if ((this.user as any).assignedDevice && this.user.role == 'subuser') {
      return new Promise<any>((resolve, reject) => {

        console.log("ASSIGNED DEVICE")
        let elem = this.afs.collection('devices').doc((this.user as any).assignedDevice).get().toPromise().then(d => {
          console.log('DATA:', d.data())

          resolve([{ id: d.id, data: d.data() }])
        }).catch(err => reject(err))
      })
    }
    else
      return new Promise<any>((resolve, reject) => {
        this.afs.collection('devices').ref.where('parent', '==', this.user.uid).get().then(d => {
          console.log(d.docs.map(v => { return ({ id: v.id, data: v.data() }) }))
          resolve(d.docs.map(v => { return ({ id: v.id, data: v.data() }) }))
        }).catch(err => {
          reject(err)
        })
      })
  }


  getModuleActiveByUser(uid) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('devices').ref.where('parent', '==', uid).get().then(d => {

        let devices = d.docs.map(v => { return ({ id: v.id, data: v.data() }) })
        let activeModules = {}
        devices.forEach(item => {
          let deviceModules = item.data.modules;
          for (const property in item.data.modules) {
            if (deviceModules[property])
              activeModules[property] = deviceModules[property];
          }
        })
        this.globalActiveModule.next(activeModules);
      })
    })
  }

  /**
  * Return promise with the module from a type, the selected group and the selected device
  *
  * @param type The module's type
  * @param group The module's group
  * @param device The module's device
  * @param userId The user's id
  */
  getModuleFromDeviceFromUser(type, group, device, userId) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('modules').ref.where('parent', '==', userId).where('group', '==', group).where('device', '==', device).where('type', '==', type).get().then(d => {


        let array = d.docs.map(v => { return { id: v.id, data: v.data() } })

        resolve(array[0])
      }).catch(err => {
        reject(err)
      })


    })
  }



  /**
   * Return promise with the module from a type, the selected group and the selected device
   *
   * @param type The module's type
   * @param group The module's group
   * @param device The module's device
   */

  getModuleFromDevice(type, group, device) {

    return new Promise<any>((resolve, reject) => {
      this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('group', '==', group).where('device', '==', device).where('type', '==', type).get().then(d => {


        let array = d.docs.map(v => { return { id: v.id, data: v.data() } })


        resolve(array[0])
      }).catch(err => {
        reject(err)
      })


    })
  }



  getFileNameFromURL(url: string) {
    this.storage.storage.refFromURL(url).getMetadata().then((d) => {

    })

  }

  getFileFromName(name): Promise<any> {
    return new Promise<any>((resolve, rejecct) => {
      this.storage.storage.ref(`users/${this.user.displayName}/media/${name}`).getDownloadURL().then(d => {
        resolve({
          url: d, firePath: `users/${this.user.displayName}/media`
        })
      }).catch(err => {
        resolve({ url: null, firePath: null });
      })
    })
  }

  getWebConfigFromName(name, device): Promise<any> {

    // console.log(name, this.user.uid, device)
    return new Promise<any>((resolve, reject) => {
      return this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', 'kiosk').where('deviceId', '==', device.id).get().then(d => {
        let data = d.docs.map(v => { return { id: v.id, data: v.data() } })


        if (data.length == 0) {
          this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', 'kiosk').where('device', '==', device.data.name).where('group', '==', device.data.group).get().then(f => {
            data = f.docs.map(v => { return { id: v.id, data: v.data() } })

            resolve(data);
          })
        }
        else
          resolve(data);
      })
    })
  }

  /**
   * Set data in corresponding module if not exist, if exist create new module.
   *
   * @param type The module's type
   * @param group The module's group
   * @param device The module's device
   * @param data The data to save in the module
   */
  setModuleFromDevice(type, group, device, data) {
    data['type'] = type;
    data['group'] = group;
    data['device'] = device;
    data['parent'] = this.user.uid;
    this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('group', '==', group).where('device', '==', device).where('type', '==', type).get().then((documentSnapshot) => {

      let id = documentSnapshot.docs.map(v => v.id)

      if (id.length == 0) {
        this.afs.collection('modules').add(data);
      }
      else {
        this.afs.collection('modules').doc(id[0]).set(data, { merge: true });
      }

    })
  }

  /**
   *
   * Update active quiz in module settings
   *
   * @param quizId The quiz's id
   * @param moduleId The modules's id
   */

  updateActiveQuizInModule(quizId, moduleId) {
    return this.afs.collection('modules').doc(moduleId).update({ activeQuiz: quizId })
  }


  /*
  getAllDevicesFromGroup() {
    return this.afs.collection('users').doc(this.user.uid).collection('groups').get().toPromise()
  }*/

  /**
   *
   * @param event
   * @param folder
   */

  openConfirModal() {

  }


  checkFileSize(data): boolean {
    let canUpload = true;

    if (data.type.includes('image') && data.size > 20971520) {
      canUpload = false;
    }
    else if (data.type.includes('video') && data.size > 9524288000) {
      canUpload = false;
    }

    return canUpload
  }

  /**
   * Upload multiple files
   * @param files FileList
   * @param folder folder name
   */
  multiUpload(fileData) {






    fileData.forEach((item) => {





      /*
            if (!this.checkFileSize(item.data)) {
              this.global.allUploadPercentObserver.next("La taille du fichier n\'est pas valide. (2Mb pour une image - 200Mb pour une video)")
            }*/

      if (!item.exist) {

        if (this.checkFileSize(item.data)) {

          const task = this.storage.upload(item.path, item.data);

          let uploadPercent = task.percentageChanges();
          // get notified when the download URL is available


          let fileRef = this.storage.ref(item.path)
          task.snapshotChanges().pipe(
            finalize(() => fileRef.getDownloadURL().subscribe(data => {
              let tmp = { name: item.data.name, url: data }

              item.url = data;
              item.downloaded = true;
              this.global.allUploadPercentObserver.next(fileData)
            }))
          )
            .subscribe((data) => {

            })

          uploadPercent.subscribe((d) => {


            item.percent = d;
            this.global.allUploadPercentObserver.next(fileData)
          })
        }
        else if (!this.checkFileSize(item.data)) {
          item.oversize = true;
          item.downloaded = true;
          this.global.allUploadPercentObserver.next(fileData)
        }
      }
    })
  }

  getUrlFromPath(path) {
    // return new Promise<any>((resolve, reject) => {
    return this.storage.ref(path).getDownloadURL().toPromise();
    // })
  }

  /**
   *  Upload file in firestorage
   * @param event
   * @param folder Folder for storage in firestorage
   */
  uploadFiles(filelist, folder) {
    let dataFiles = [];
    let promises: any = [];



    return new Promise<any>((resolve, reject) => {


      let arrayFiles = Array.from(filelist)


      //  if (arrayFiles.length > 1) {




      arrayFiles.forEach((file: any) => {
        let filePath



        let rulesFilename = file.name
        let tmp = file;

        let extension = tmp.name.slice((Math.max(0, tmp.name.lastIndexOf(".")) || Infinity) + 1)

        let newFilename = `${uuidv4().replaceAll('.', '')}.${extension}`
        if (folder.includes('rules'))
          filePath = 'users/' + this.user.displayName + '/' + folder + '/rules.jpg'// + rulesFilename.substring(rulesFilename.lastIndexOf('.') + 1, rulesFilename.length) || rulesFilename;
        else
          filePath = 'users/' + this.user.displayName + '/' + folder + '/' + newFilename;

        //tmp.name = newFilename

        let newFile = new File([tmp], newFilename, {
          type: tmp.type,
        })

        dataFiles.push({ exist: false, data: newFile, path: filePath, defaultName: file.name, name: newFilename })




        /*    promises.push(this.storage.storage.ref('users/' + this.user.displayName + '/' + folder).child(file.name).getMetadata().then(d => {

              if (d.size == file.size)
                dataFiles.push({ exist: true, data: file, path: filePath })
              else {

             // }

            }).catch(err => {
              if (err.code == "storage/object-not-found")
                dataFiles.push({ exist: false, data: file, path: filePath })
            }))*/
      })


      Promise.all(promises).then((d) => {
        this.dialogRef = this.dialog.open(ProgressbarmodalComponent, {
          data: {
            multiple: true,
            fileData: dataFiles
          },
          height: '50vh'
        })

        this.dialogRef.afterClosed().subscribe(result => {
          if (result) {

            /*  let tmp = [];
                        result.forEach((item, index) => {
                          if (item.oversize)
                            tmp.push(index);
                        })*/
            for (let i = result.length; i >= 0; i--) {
              if (result[i] != undefined && result[i].oversize)
                result.splice(i, 1);
            }




            resolve(result)
          }
          else
            reject("ERROR UPLOAD");
        })

      })

    })
  }



  /**
   * Return the number on time the file is found in different table
   * @param url file's url
   */
  checkIfTimeFileUsed(url) {
    let imageCount = 0;

    return new Promise<any>((resolve, reject) => {
      this.afs.collection('devices').ref.where('parent', '==', this.user.uid).get().then(d => {
        let devicesData = d.docs.map(v => v.data()) as any;

        devicesData.forEach((deviceItem) => {
          if (deviceItem.config.listBackgrounds.length > 0)
            deviceItem.config.listBackgrounds.forEach((background) => {
              if (background == url) {
                // console.log('IS BACKGROUND')
                imageCount++;
              }

            })
        })

        this.afs.collection('modules').ref.where('parent', '==', this.user.uid).get().then(e => {
          let modulesData = e.docs.map(v => v.data()) as any;;


          modulesData.forEach((moduleItem: any) => {

            if (moduleItem.type == 'kiosk') {
              moduleItem.urlConfig.forEach((urlItem) => {
                if (url && urlItem && (urlItem.url == url)) {
                  //  console.log('IS IN KIOSK')
                  imageCount++;
                  //   console.log(imageCount, urlItem.url, url)
                }

              })
            }
            if (moduleItem.type == 'quiz') {
              if (moduleItem.urlRules && url && moduleItem.urlRules == url) {
                // console.log("IS IN QUIZ")
                imageCount++;
                //   console.log(imageCount, moduleItem, moduleItem.urlRules)
              }

            }


            if (moduleItem.type == 'media') {

              let loopThrough = function (tab) {

                tab.forEach((tabItem) => {
                  if (tabItem.type == 'file' && tabItem.url == url) {
                    //  console.log("IS FILE")
                    imageCount++;

                  }

                  if (tabItem.type == 'web' && tabItem.thumbnail != undefined && tabItem.thumbnail == url) {
                    // console.log('IN WEB')
                    imageCount++;
                  }

                  if (tabItem.children != undefined && tabItem.children.length > 0)
                    loopThrough(tabItem.children);
                })

              }
              loopThrough(moduleItem.fileTree);
              if (moduleItem.backup && moduleItem.backup.urlImageBackUpArray && moduleItem.backup.urlImageBackUpArray.includes(url)) {
                // console.log("IN BACKUP")
                imageCount++;
                //  console.log(imageCount)
              }
            }
            //  console.log(imageCount)
          })
          if (url)
            this.afs.collection('media').ref.where('url', '==', url).get().then(f => {
              let mediaItems = f.docs.map(v => v.data())
              if (mediaItems.length > 1)
                imageCount += mediaItems.length;
              //  console.log("IS URL MEDIA")
              this.afs.collection('media').ref.where('thumbnail.url', '==', url).get().then(g => {
                let mediaThumbnailItems = g.docs.map(v => v.data())
                if (mediaThumbnailItems.length > 1)
                  imageCount += mediaThumbnailItems.length;
                //  console.log("IS THUMBNAIL MEDIA")
                this.afs.collection('questions').ref.where('parent', '==', this.user.uid).where('type', '==', 'qcm').where('urlMedia', '==', url).get().then(h => {
                  let questionsItems = h.docs.map(v => v.data());

                  if (questionsItems.length > 1)
                    imageCount += questionsItems.length;
                  //  console.log("IS QUESTION ITEM MEDIA")
                  resolve(imageCount)
                  //   console.log(imageCount)
                })
              })
              //  console.log(imageCount)
            })
          else {
            //  console.log("NO URL")
          }
        })
      }).catch(err => {
        console.log(err)
      })
    })
  }


  /**
   * Upload file in firestorage with custom filename
   * @param event
   * @param folder Folder for storage in firestorage
   * @param filename Filename
   */
  uploadFilesCustomName(event, folder, filename) {

    const file = event;
    const filePath = 'users/' + this.user.displayName + '/' + folder + '/' + filename;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    let uploadPercent = task.percentageChanges();
    // get notified when the download URL is available



    return new Promise<any>((resolve, reject) => {
      task.snapshotChanges().pipe(
        finalize(() => fileRef.getDownloadURL().subscribe(data => {
          let tmp = { name: file.name, url: data }

          resolve(data)
        }))
      )
        .subscribe((data) => {

        })
    })


  }


  /* getObservablesFromPath(path): Observable<any> {
     return this.afs.doc(path).snapshotChanges().pipe(
       map(changes => {
         const data = changes.payload.data();
         const id = changes.payload.id;
         return { id, ...data }
       })
     )

   }*/

  /**
   * Return saved user
   * */
  getLocalUser(): User {
    return this.user;
  }

  /**
   * Set user
   * @param user User data
   */
  setLocalUser(user: any) {
    if (user.role == 'subuser') {
      user.subuid = user.uid
      user.uid = user.parentuid
    }

    this.user = user

    this.userCheck.next(this.user)
  }

  /**
   *
   * */
  getUsersCollection(): Observable<any> {
    return this.userCollection.snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data };
      }))
    );
  }


  /**
   * Return a snapshot of user data
   * @param userId The user's id
   */
  getUserData(userId): Observable<any> {
    return this.afs.doc(`users/${userId}`).snapshotChanges().pipe(
      map(changes => {

        const data = changes.payload.data();
        const id = changes.payload.id;


        return data;
        // return { id, ...data }
      })
    )

  }

  getUserDataByEmail(email): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('users').ref.where('email', '==', email).get().then(d => {
        let res = d.docs.map(v => {
          return { id: v.id, data: v.data() }
        })

        resolve(res[0]);
      });
    })

  }

  /**
   * If doesn't exist create new user in Firestore with data, else set user with  new data
   * @param userId The user's id
   * @param data The user's data to save
   */

  setUserDataElement(userId, data) {


    return this.afs.doc(`users/${userId}`).set({ uid: userId, email: data.email, displayName: data.displayName, role: data.role, createdAt: data.createdAt, groupsArray: data.groupsArray })
  }




  /**
   * Create new user in Firebase Authentification (custom server running) ans return promise
   * @param email The user's email
   * @param role The user's role ('user', 'admin')
   * @param displayName The user's display name
   * @param password The user's password
   */
  createUser(email, role, displayName, password) {
    /*  let header = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'PTXSHVM2lD5eP4JOXoLJuIKHbTHpyIYp',

      })*/
    return new Promise<any>((resolve, reject) => {
      this.afAuth.auth.createUserWithEmailAndPassword(email, password).then(d => {


        return this.afs.collection('users').doc(d.user.uid).set({
          email: email,
          displayName: displayName,
          role: role,
          createdAt: new Date(),
          uid: d.user.uid
        }).then(e => {
          resolve('OK');
        }).catch(err => {
          reject(err)
        })


      }).catch(err => {
        reject(err);
      })
    })

    /*  return new Promise<any>((resolve, reject) => {
        this.http.post(this.adminFirebaseUrl + '/newuser', { email: email, password: password }, { headers: header }).subscribe((data: any) => {
          if (data.message == 'OK') {
            this.setUserDataElement(data.uid, { email: email, role: role, displayName: displayName, createdAt: new Date(), groupsArray: [{ name: 'default', devices: [] }] }).then((data) => {
              resolve('user created')
            }).catch(err => {
              reject(err)
            })
          }
          else
            reject(data.message)
        })
      })*/


  }


  checkIfDeviceExist(borneName, groupName, groupId) {
    if (groupId)
      //return new Promise<any>((resolve, reject) => {
      return this.afs.collection('devices').ref.where('parent', '==', this.user.uid).where('groupId', '==', groupId).where('name', '==', borneName)
    else
      return this.afs.collection('devices').ref.where('parent', '==', this.user.uid).where('group', '==', groupName).where('name', '==', borneName)
    //  })

  }

  /**
   * Create new device in Firestore
   * @param data The device's data
   * @param user The user's data
   */
  addDevice(data, user) {

    return new Promise<any>((resolve, reject) => {
      this.afs.collection('devices').add({
        name: data.name, parent: user.uid, group: data.group, groupId: data.groupId, config: {
          backgroundURL: data.backgroundURL,
          colorText: '#000000',
          galleryEnable: false,
          activeAnim: true,
          activeDate: true,
          activeText: true,
          activeTextBackground: true,
          activeWeather: true,
          selectedCity: {
            id: 6455259,
            name: "Paris"
          },
          inactivity: 60,
          listBackgrounds: data.listBackgrounds,
          password: '0000',
          startText: 'Touchez l\'écran pour commencer !',
          timerSlideshow: 5,
        }
      }).then(data => {
        resolve(data.id)
      }).catch(err => {
        reject(err)
      })
    })
  }
  /**
   * Create new group in Firestore
   * @param groupName The group's name
   * @param user The group's user
   */
  addGroup(groupName, user) {
    return this.afs.collection('groups').add({ name: groupName, parent: user.uid })
  }

  createActivity(type, mediaData) {
    return new Promise<any>((resolve, reject) => {
      //  if (this.user.role == 'mainuser' || this.user.role == 'subuser') {
      let data: any = { createdAt: new Date(), type: type, email: this.user.email, mediaData: mediaData, deviceId: this.selectedDeviceFirebaseService.id }
      if (this.user.role == 'subuser') {
        data.uid = this.user.subuid;
        data.parentuid = this.user.uid
      }
      else {
        data.uid = this.user.uid;
        data.parentuid = this.user.uid
      }



      return this.afs.collection('activity').add(data).then(d => {
        resolve('OK');
      })
      /*  }
        else
          resolve();*/

    })


  }


  setMedia(id, data) {
    this.afs.collection('media').doc(id).set(data);
  }

  /**
  * Create new media in Firestore
  * @param type The media's type (folder/file)
  * @param path The media's path (. for root folder)
  */

  addMedia(type, name, moduleData: any = {}) {

    console.log(type, name, moduleData)
    return new Promise<any>((resolve, reject) => {
      if (type == 'folder')
        this.afs.collection('media').add({ type: type, background: { url: '', firestoragePath: '' }, active: true, name: name, displayName: moduleData.displayName || name, thumbnail: { url: '', firestoragePath: '' }, createdAt: new Date() }).then(d => {
          this.createActivity('create', { id: d.id, name: name, type: type }).then(() => {
            resolve(d)
          })

        })
      else if (type == 'file')
        this.afs.collection('media').add({ type: type, active: true, name: name, displayName: moduleData.defaultName, /*path: moduleData.path,*/ firestoragePath: moduleData.firePath, url: moduleData.url, createdAt: new Date() }).then(d => {
          return this.createActivity('create', { id: d.id, name: name, type: type }).then(() => {
            resolve(d)
          })

        });
      else if (type == 'web')
        this.afs.collection('media').add({ type: type, active: true, name: name, url: moduleData.url, thumbnailUrl: moduleData.thumbnail, id: moduleData.id, filename: moduleData.filename, createdAt: new Date() }).then(d => {
          return this.createActivity('create', { id: d.id, name: name, type: type }).then(() => {
            resolve(d)
          })

        });
      else if (type == 'quiz')
        this.afs.collection('media').add({ type: type, active: true, name: name, idModule: moduleData.idModule, idQuiz: moduleData.idQuiz, createdAt: new Date() }).then(d => {
          return this.createActivity('create', { id: d.id, name: name, type: type }).then(() => {
            resolve(d)
          })

        });
      else if (type == 'lottery') {

        this.afs.collection('media').add({ type: type, active: true, name: name, displayName: name, thumbnail: moduleData.thumbnail, createdAt: new Date() }).then(d => {
          return this.createActivity('create', { id: d.id, name: name, type: type }).then(() => {
            resolve(d)
          })

        });
      }
    })

  }

  updateMediaData(data, id) {



    return this.afs.collection('media').doc(id).update(data).then(d => {

      this.createActivity('update', { id: id })

    });
  }

  removeFileFromUrl(url) {
    return this.storage.storage.refFromURL(url).delete()
  }

  removePreviousImg(id, type, url = null) {

    return new Promise<void>((resolve, reject) => {

      if (id != undefined && id != null)
        this.afs.collection('media').doc(id).get().toPromise().then(d => {
          let data = d.data();
          if (data[type].firestoragePath != undefined && data[type].firestoragePath.length > 0) {
            //    console.log("BEFORE CHECK IF USED", url, data)
            this.checkIfTimeFileUsed(url).then(d => {
              //    console.log("CHECK IF FILE USED", d)
              if (d <= 1) {
                if (type != 'thumbnail' && type != "background")
                  this.storage.ref(data[type].firestoragePath).delete().toPromise().then(() => {
                    //     console.log("DELETE FILE")
                    resolve();
                  }).catch(err => {
                    console.log(err);
                  /*reject(err)*/resolve()
                  });
                else if (type == 'thumbnail' || type == 'background')
                  this.storage.storage.refFromURL(url).delete().then(() => {
                    //      console.log("DELETE FILE")
                    resolve();
                  }).catch(err => {
                    console.log(err);
                  /*reject(err)*/resolve()
                  });
              }
              else
                resolve();

            })




          }

          else
            resolve();
        })

      else {
        if (url != null && url.length > 0) {
          this.checkIfTimeFileUsed(url).then(d => {
            if (d <= 1) {
              this.storage.storage.refFromURL(url).delete().then((d) => {
                resolve()
              }).catch(err => {
                console.log(err);
                resolve();
              })
            }
            else
              resolve();
          })
        }
        else
          resolve();
        //  this.storage.ref(`users/${this.user.displayName}/media/${name}`)
      }
    })

  }

  getMedia(id) {
    return this.afs.collection('media').doc(id).get().toPromise()
  }

  updateMediaName(id, name, elem) {
    return this.afs.collection("media").doc(id).update({ name: name }).then(d => {
      this.createActivity('update', { id: id, name: name, type: elem.type })

    })
  }

  updateMediaDisplayNameAndTranslation(id, name, lang, elem) {



    return this.afs.collection("media").doc(id).update({ displayName: name, langArray: lang }).then(d => {
      this.createActivity('update', { id: id, name: name, type: elem.type })
    })
  }

  updateMediaDisplayName(id, name, elem) {

    return this.afs.collection("media").doc(id).update({ displayName: name }).then(d => {
      this.createActivity('update', { id: id, name: name, type: elem.type })

    })
  }

  getSubUserList() {

    return new Promise<any>((resolve, reject) => {
      this.afs.collection('users').ref.where('parentuid', '==', this.user.uid).get().then(d => {

        let datas = d.docs.map(v => v.data())
        resolve(datas)
      }).catch(err => {
        reject(err)
      })
    })

  }



  deleteMedia(id, device = null) {

    return new Promise<any>((resolve, reject) => {

      /*Check if document is used in another media module*/
      this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', 'media').get().then(d => {
        let datas = d.docs.map(v => v.data())

        let count = 0;

        datas.forEach((item) => {

          let loopThrough = (e) => {
            if (this.isIterable(e))
              for (let item of e) {
                if (item.id == id) {
                  count++;
                }
                if (item.children != undefined && item.children.length > 0)
                  loopThrough(item.children)
              }
          }
          loopThrough(item.fileTree)



        })


        if (count <= 1) {
          this.afs.collection('media').doc(id).get().toPromise().then(data => {
            this.afs.collection('media').doc(id).delete().then(d => {
              let displayName = data.data().displayName;
              if (!displayName)
                displayName = data.data().name;


              this.createActivity('delete', { id: id, name: displayName, type: data.data().type })

            });
            /*  if (device != null) {
                this.deleteStatFromIdMedia(device.data.name, id)
              }*/
          })

          resolve(false);
        } else
          resolve(true)


      })
    })




    /*
*/




  }

  deleteStatFromIdMedia(deviceName, idMedia) {
    this.afs.collection('stats').ref.where('parent', '==', this.user.uid).where('deviceName', '==', deviceName).get().then(d => {
      let idDevice = d.docs.map(v => v.id)[0];

      this.afs.collection('stats').doc(idDevice).collection('mediaData').ref.where('idMedia', '==', idMedia).get().then(md => {
        let docsId = md.docs.map(v => v.id)


        docsId.forEach(item => {
          this.afs.collection('stats').doc(idDevice).collection('mediaData').doc(item).delete();
        })
      })
    })
  }

  deleteStatFromMediaId(idMedia, idStat) {

    let array = []
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('stats').doc(idStat).collection('mediaData').ref.where('idMedia', '==', idMedia).get().then(d => {


        d.docs.map(v => array.push(v.ref.delete()))


        Promise.all(array).then(d => {
          resolve('OK')
        }).catch(err => {
          console.log(err);
        })

      })
    })

  }

  getDocDataAndDeleteFile(id) {
    return this.afs.collection('media').doc(id).get().toPromise().then((d: any) => {


      if (d.data()) {
        let firestoragePath = d.data().url//`${d.data().firestoragePath}/${d.data().name}`

        if (d.data().thumbnail && d.data().thumbnail.url.length > 0) {

          this.checkIfTimeFileUsed(d.data().thumbnail.url).then(d => {
            if (d <= 1)
              this.storage.storage.refFromURL(d.data().thumbnail.url).delete()
          })

        }

        this.deleteMedia(id).then(isUsed => {
          if (!isUsed)
            this.checkIfTimeFileUsed(firestoragePath).then(d => {
              if (d <= 1) {
                this.storage.storage.refFromURL(firestoragePath).delete()
              }

            })
        });

      }
      else {
        this.deleteMedia(id);
      }


    })
  }

  /**
   * Update group in user data
   * @param id The user's id
   * @param groupsData The group's data
   */
  updateGroupArrayUser(id, groupsData) {
    this.userSub.unsubscribe();
    this.afs.doc(`users/${id}`).update({ groupsArray: groupsData })
  }

  updateUserData(data, userId) {



    return this.afs.doc(`users/${userId}`).update(data)
  }

  updateUserPassword(user, str) {
  }

  updatePassword(str) {
    this.afAuth.auth.currentUser.updatePassword(str).then(d => {

    }).catch(err => {
      console.log(err)
    })
  }

  async resetPasswordSendEmail(email): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.auth.sendPasswordResetEmail(email).then(d => {
        resolve('OK')
      }).catch(err => {
        console.log(err)
        reject(err)
      })

    })

  }

  updateDeviceById(id, data) {

    // console.log(data);
    this.afs.collection('devices').doc(id).update(data);
  }


  async copyFileToAnotherFirestorageFolder(name, dest, extension) {


    dest = `${dest}/${uuidv4().replaceAll('.', '')}.${extension}`
    return new Promise<any>((resolve, reject) => {
      let that = this;
      console.log(name)
      this.storage.ref(`defaultMedia/${name}`).getDownloadURL().toPromise().then(d => {
        let fileArray = new Uint8Array()
        fetch(d).then(htmlReturn => {
          const reader = htmlReturn.body.getReader();


          // console.log(reader)
          reader
            .read()
            .then(function appendStreamChunk({ done, value }) {
              //If the reader doesn't return "done = true" append the chunk that was returned to us
              // rinse and repeat until it is done.
              if (value) {
                fileArray = that.mergeTypedArrays(fileArray, value)
              }
              if (done) {
                //  console.log(fileArray)
                return fileArray
              } else {
                // "Readout not complete, reading next chunk"
                return reader.read().then(appendStreamChunk)
              }
            })
            .then(file => {
              //Write the file to the new storage place
              //   console.log(user)

              let status = this.storage.upload(dest, file).then(() => {
                this.storage.ref(dest).getDownloadURL().toPromise().then(d => {
                  resolve(d)
                  console.log(d)
                })
              })
            })
        })
      })
    })

  }

  async generateDefaultFileTree(user): Promise<any> {
    interface defaultFiletreeItem {
      name: string,
      type: string,
      path: string,
      children?: Array<defaultFiletreeItem>
    }
    return new Promise<any>((resolve, reject) => {
      let defaultConfig: Array<defaultFiletreeItem> = [{ name: 'default_image_1.jpg', type: 'file', path: '.' },
      { name: 'default_video.mp4', path: '.', type: 'file' },
      {
        name: "default_folder", type: 'folder', path: '.', children: [
          { name: 'default_image_2.jpg', type: 'file', path: './default_folder' },
          { name: 'default_pdf.pdf', type: 'file', path: './default_folder' },
          {
            name: 'default_folder_2', type: 'folder', path: './default_folder', children: [
              { name: 'default_image_3.jpg', type: 'file', path: './default_folder/default_folder_2' }
            ]
          }
        ]
      }]


      //  return new Promise<any>( (resolve, reject) => {

      let PromiseList = [];

      let loopThrough = (tab) => {
        for (const elem of tab) {
          if (elem.type == 'folder') {

            PromiseList.push(new Promise<any>((resolve, reject) => {

              this.addMedia("folder", elem.name, { displayName: elem.name }).then(d => {
                elem.id = d.id;
                elem.displayName = elem.name
                elem.createdAt = new Date();
                resolve(null)
              })/*
              setTimeout(() => { console.log(elem); resolve(null) }, 1000)
            }))*/



              if (elem.children) {
                loopThrough(elem.children)
              }
            }))
          }
          else if (elem.type == 'file') {
            PromiseList.push(new Promise<any>((resolve, reject) => {
              elem.displayName = elem.name
              this.copyFileToAnotherFirestorageFolder(elem.name, `users/${user}/test`, elem.name.split('.')[1]).then(d => {
                this.addMedia("file", elem.name, { defaultName: elem.name, firePath: `users/${user}/test`, url: d }).then(e => {
                  elem.id = e.id;
                  elem.url = d;
                  elem.createdAt = new Date();
                  resolve(null);
                })
              })
              /*     setTimeout(() => { console.log(elem); resolve(null) }, 1000)*/
            }))

          }
        }
      }

      loopThrough(defaultConfig)

      Promise.all(PromiseList).then(d => {
        resolve(defaultConfig)
        console.log(defaultConfig)
      }).catch(err => {
        console.log(err)
      })
    })


    /* defaultConfig.forEach((item) => {
 
      })*/

    //  this.addMedia('folder', 'Dossier', )



    //  })

  }

  /**
   * Update the device data
   * @param module The module's type
   * @param value The value to update
   * @param device The device's data
   * @param user The user's data
   */
  updateDevice(module, value, device, user) {
    let modules;

    console.log("UPDATE DEVICE")
    return new Promise<void>((resolve, reject) => {
      this.afs.collection('modules').ref.where('parent', '==', user).where('group', '==', device.data.group).where('device', '==', device.data.name).where('type', '==', module.name).get().then(d => {

        if (value == true && d.docs.map(v => v.data()).length <= 0) {
          if (module.name == 'kiosk')
            this.afs.collection('modules').add({ parent: user, group: device.data.group, device: device.data.name, deviceId: device.id, type: module.name, urlConfig: [{}] }).then(() => { resolve(); })
          else if (module.name == 'media') {


            /* Add Default Media Options */

            /*this.generateDefaultFileTree().then(d => {

            })*/


            this.afs.collection('modules').add({ parent: user, group: device.data.group, device: device.data.name, deviceId: device.id, type: module.name, fileTree: [] }).then(() => { resolve(); })
          }
          else if (module.name == 'lottery') {

            let defaultPrizerArray = [{
              color: "#232323",
              currentQuantity: 0,
              descriptif: "Perdu",
              isWinner: false,
              nbr: 0,
              resultText: "Vous avez perdu",
              special: false
            }, {
              color: "#7301fb",
              currentQuantity: 10,
              descriptif: "Lot n°1",
              isWinner: true,
              nbr: 10,
              resultText: "🎉 Vous avez remporté le Lot n°1",
              special: false
            }, {
              color: "#40c200",
              currentQuantity: 10,
              descriptif: "Lot n°2",
              isWinner: true,
              nbr: 10,
              resultText: "🎉 Vous avez remporté le Lot n°2!",
            }]

            let defaultSoundObject = {
              loop: {
                data: { name: null, url: null },
                enable: false
              },
              win: { data: { name: null, url: null }, enable: false },
              lose: { data: { name: null, url: null }, enable: false }
            }

            this.afs.collection('modules').add({ parent: user, group: device.data.group, device: device.data.name, deviceId: device.id, type: module.name, config: { Nbr_total_lot: 20, colorBackground: "#FFFFFF", current_Nbr_total_lot: 20, endBackground: { name: null, url: null }, endTime: "17:00", startTime: '08:00', startDate: new Date(), endDate: new Date(), latestGame: new Date(), gameActive: true, gameType: 'wheel', prizeArray: defaultPrizerArray, startText: "Lancer le jeu !", sound: defaultSoundObject } }).then(() => {
              resolve();
            })
          }
          else if (module.name == 'quiz') {
            this.afs.collection('modules').add({ parent: user, group: device.data.group, device: device.data.name, deviceId: device.id, type: module.name }).then(dQuiz => {


              this.addQuiz('Defaut', device.data.name, device.data.group, dQuiz.id).then(dToLottery => {
                if (device.data.modules.lottery) {
                  this.updateActiveQuizInModule(dToLottery.id, dQuiz.id).then(() => { resolve(); })

                }
                else
                  resolve();
              })


            })
          }
          else
            this.afs.collection('modules').add({ parent: user, group: device.data.group, device: device.data.name, deviceId: device.id, type: module.name }).then(() => {
              resolve();
            })
        }
        else {
          console.log("NEED TO CHECK IF DEVICE ID", device)

          console.log(device.data.parent, device.data.group, device.data.name, module.name, device.id)
          this.afs.collection('modules').ref.orderBy('deviceId').where('parent', '==', device.data.parent).where('group', '==', device.data.group).where('device', '==', device.data.name).where('type', '==', module.name).get().then(d => {
            let datalist = d.docs.map(v => {
              return { id: v.id, data: v.data() }
            })

            if (datalist.length == 0) {
              console.log("MODULE NOT FOUND LIST")

              this.afs.collection('modules').ref.where('parent', '==', device.data.parent).where('group', '==', device.data.group).where('device', '==', device.data.name).where('type', '==', module.name).get().then(docs => {
                docs.docs[0].ref.update({ deviceId: device.id })
                //console.log(docs.docs[0].data())


              })

            }

            console.log(datalist)
          })
        }


      })


      this.afs.collection('devices').doc(device.id).get().toPromise().then((currentData: any) => {


        if (currentData.data().modules) {
          modules = currentData.data().modules


          for (let property in device.data.modules) {

            let tmp = device.data.modules
            if (tmp.hasOwnProperty(property)) {
              // Do things here

              modules[property] = tmp[property]

            }
          }



          modules[module.name] = value;
          // console.log("UPDATE MODULE", modules, device,)

          if (device.data.groupId) {
            //           console.log("ALREADY GROUP ID")
            this.afs.collection('devices').doc(device.id).update({ modules: modules, groupId: device.data.groupId }).then(() => { resolve(); })
          }

          else
            this.afs.collection('groups').ref.where('parent', '==', device.data.parent).where('name', '==', device.data.group).get().then((data) => {


              let id = data.docs.map(v => v.id)[0]

              //   console.log("ENABLE GROUPE ID", id)
              this.afs.collection('devices').doc(device.id).update({ modules: modules, groupId: id }).then(() => { resolve(); })
            })



        }
        else {
          let key = module.name
          let modules = {};
          modules[key] = value

          if (module.name == 'lottery') {
            modules['data'] = true;
            modules['quiz'] = true
          }



          this.afs.collection('devices').doc(device.id).update({ modules }).then(() => { resolve(); })
        }
      })
    })

  }

  /**
   * Update the 'config' key in device
   * @param config The config's data
   * @param id The device's id
   */
  updateConfigDevice(config, id) {
    return this.afs.collection('devices').doc(id).update({ 'config': config })
  }

  isIterable(obj) {
    if (obj == null) {
      return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
  }

  cleanData(tab) {

    let loopThrough = (e) => {
      if (this.isIterable(e))
        for (let item of e) {


          //    console.log(item)
          if (item && item.mediaOptions) {

            delete item.mediaOptions;
          }

          else if (item.children != undefined && item.children.length > 0)
            loopThrough(item.children)
        }
    }
    loopThrough(tab)
    return tab;
  }


  checkModifTimestamp(res, id, type = 'modules'): Promise<any> {
    return new Promise<any>((resolve, reject) => {

      this.afs.collection(type).doc(id).get().toPromise().then(d => {

        if (!d.data().latestUpdate) {
          resolve(true);
          return;
        }
        let distantDate = new Date(d.data().latestUpdate.seconds * 1000 + d.data().latestUpdate.nanoseconds / 1000000)//.toUTCString()
        let localDate;
        if (res.seconds)
          localDate = new Date(res.seconds * 1000 + res.nanoseconds / 1000000)//.toUTCString()
        else
          localDate = new Date(res)


        console.log(localDate.toString(), distantDate.toString())
        if (localDate.toString() != distantDate.toString()) {


          this.dialogRef = this.dialog.open(ModalTextComponent, {
            data: 'Une modification des données a eu lieu, veuillez recharger le module.'
          })

          resolve(false)
        }
        else
          resolve(true)
      })
    })



  }

  /**
   * Update the module's data
   * @param data The new module's data
   * @param id The module's id
   */
  updateConfigModule(data, id, type = 'modules') {


    return new Promise<any>((resolve, reject) => {

      console.log(data)
      let currentData = JSON.parse(JSON.stringify(data));
      //console.log("CHECK TIME STAMP DATA", currentData)
      this.checkModifTimestamp(currentData.latestUpdate, id, type).then(d => {
        if (d) {
          data.latestUpdate = new Date();
          let res;
          if (data.fileTree) {
            let tmp = JSON.parse(JSON.stringify(data.fileTree))
            res = data;
            res.fileTree = this.cleanData(tmp)

          }
          else {
            res = data;
          }
          resolve(data.latestUpdate)
          this.selectedModuleData = res;
          this.afs.collection(type).doc(id).update(res);
        }

      })
    })



  }


  updateGlobalSettingsOfAllGroup(data, groupe, deviceId) {

    // console.log(data, groupe, deviceId)
    return new Promise<void>((resolve, reject) => {
      this.afs.collection('devices').ref.where('parent', '==', this.user.uid).where('group', '==', groupe).get().then(d => {
        let docs = d.docs.map(v => {

          return { id: v.id, data: v.data() }
        });




        docs.forEach((item: any) => {

          if (item.id != deviceId) {

            this.afs.collection('devices').doc(item.id).update({ config: data });
            item.data.config.listBackgrounds.forEach(elem => {


              if (!data.listBackgrounds.includes(elem))
                this.removeImg(elem);
            })
          }

        })
        resolve();


      }).catch(err => {
        console.log(err)
        reject(err)
      })

    })

  }


  updateGlobalSettingsForDevice(data, group, deviceId, deviceToUpdate) {
    return new Promise<void>((resolve, reject) => {
      let promiseList = [];
      deviceToUpdate.forEach((item) => {
        promiseList.push(this.afs.collection('devices').doc(item.id).get().toPromise().then(d => {
          console.log(d.data(), d.data().listBackgrounds)



          d.ref.update({ config: data });

          if (d.data().config.listBackground)
            d.data().config.listBackground.forEach(elem => {
              if (!data.listBackgrounds.includes(elem))
                this.removeImg(elem);
            })
          /*    let docs = d.docs.map(v => {
      
                return { id: v.id, data: v.data() }
              });
      
      
      
      
              docs.forEach((item: any) => {
      
                if (item.id != deviceId) {
      
                  this.afs.collection('devices').doc(item.id).update({ config: data });
                  item.data.config.listBackgrounds.forEach(elem => {
      
      
                    if (!data.listBackgrounds.includes(elem))
                      this.removeImg(elem);
                  })
                }
      
              })*/
          // resolve();


        }).catch(err => {
          //  console.log(err)
          // reject(err)
        }))


      })

      return Promise.all(promiseList).then(() => resolve()).catch(err => { reject() })
    })
  }




  async addKioskToDeviceModule(data, group, device) {

    this.afs.collection('modules').ref.where('type', '==', "kiosk").where('parent', '==', this.user.uid).where('group', '==', group).where('device', '==', device).get().then(d => {
      let docs = d.docs.map(v => {
        return v.id
      })

      let docsData = d.docs.map(v => v.data())

      this.afs.collection('modules').doc(docs[0]).get().toPromise().then((m: any) => {



        console.log(docsData[0])

        let tmpUrlConfig = m.data().urlConfig;

        //     console.log(JSON.parse(JSON.stringify(tmpUrlConfig)))

        let filename;
        let thumbnail;

        if (data?.mediaOptions && data?.mediaOptions.filename)
          filename = data.mediaOptions.filename
        else
          filename = ""

        if (data?.mediaOptions && data?.mediaOptions.thumbnail)
          thumbnail = data.mediaOptions.thumbnail
        else
          thumbnail = ""
        //       console.log(filename, data.id, data.name, thumbnail, data.url, tmpUrlConfig.find(v => v.filename == filename && v.url == data.url))


        if (!tmpUrlConfig.find(v => v.filename == filename && v.url == data.url))
          tmpUrlConfig.push({ filename: filename, id: data.id, name: data.name, thumbnailUrl: thumbnail, url: data.url })

        console.log("URLCONFIG: ", tmpUrlConfig)
        this.afs.collection('modules').doc(docs[0]).update({ urlConfig: tmpUrlConfig })
        return 'OK'

      })

    })

  }


  addLotteryToDeviceModule(media, group, device) {

    console.log(media, group, device, this.selectedDeviceFirebaseService.data.name)

    return new Promise<void>((resolve, reject) => {
      this.afs.collection('modules').ref.where('type', '==', 'lottery').where('parent', '==', this.user.uid).where('group', '==', group).where('device', '==', device).get().then(m => {
        let moduleId = m.docs.map(v => v.id)[0]
        let destModuleData = m.docs.map(v => v.data())[0]
        //  let moduleData = m.docs.map(v => v.data())[0]
        this.afs.collection('modules').ref.where('type', '==', 'lottery').where('parent', '==', this.user.uid).where('group', '==', group).where('device', '==', this.selectedDeviceFirebaseService.data.name).get().then(l => {
          console.log("ORIGIN MODULE", l)

          let originModuleData = l.docs.map(v => v.data())[0];

          if (JSON.stringify(originModuleData.config) != JSON.stringify(destModuleData.config) || JSON.stringify(originModuleData.listConfig) != JSON.stringify(destModuleData.listConfig)) {
            destModuleData = originModuleData;


           // if(dest)


            /* SET NEW VALUES */
            destModuleData.device = device;
            this.updateModule(moduleId, destModuleData).then(() => {
              resolve();
            })

    //        this.update
          }
          console.log("ORIGIN MODULE DATA",originModuleData);
        })

        //    this.afs.collection('')
        //    this.afs.collection('modules')
        console.log("MODULE ID", moduleId);
      })
    })
  }


  addQuizToDeviceModule(data, group, device) {


    return new Promise<any>((resolve, reject) => {
      this.afs.collection('modules').ref.where('type', '==', 'quiz').where('parent', '==', this.user.uid).where('group', '==', group).where('device', '==', device).get().then(m => {
        let moduleId = m.docs.map(v => v.id)

        this.afs.collection('quiz').doc(data.idQuiz).get().toPromise().then(d => {


          let quizData = d.data() as any;
          let quizId = d.id;

          if (quizData == undefined)
            reject('An error occured, quizData undefined');
          quizData.device = device;
          quizData.idModule = moduleId[0]

          this.afs.collection('quiz').ref.where('parent', '==', this.user.uid).where('group', '==', group).where('device', '==', device).where('name', '==', quizData.name).get().then(q => {
            q.docs.map(v =>
              v.ref.delete())
        this.afs.collection('quiz').add(quizData).then(newQuiz => {

            resolve(newQuiz.id);
            this.afs.collection('questions').ref.where('idQuiz', '==', quizId).get().then(q => {
              let quesDatas = q.docs.map(v => { return v.data() })
              quesDatas.forEach((elem) => {
                let tmp = elem as any;
                tmp.idQuiz = newQuiz.id
                this.afs.collection('questions').add(tmp);
              })
            })
          });
          })



        })



      })
    })






  }










  listAllDataFromFileTree(arr) {

    let array = [];
    let refCount = 0;
    let count = 0;

    let getSizeFileTree = (arr) => {

      arr.forEach((elem, index) => {
        refCount++;
        if (elem.children != undefined && elem.children.length > 0) {
          getSizeFileTree(elem.children)
        }

      })


    }
    getSizeFileTree(arr)
    return new Promise<any>((resolve, reject) => {
      let getAllMediaToCopy = (arr) => {

        arr.forEach((elem, index) => {

          if (elem.type != "web") {

            console.log(elem)
            let path = elem.path
            //   if (elem.mediaOptions == undefined)
            this.afs.collection('media').doc(elem.id).get().toPromise().then(dataMedia => {


              if (dataMedia.data()) {
                let dataSend = dataMedia.data()
                dataSend.path = path;
                dataSend.id = elem.id
                array.push(dataSend);
              }

              count++;
              if (count == refCount) {
                resolve(array)
              }


            })
            /*   else {
                 elem.mediaOptions.path = elem.path;
                 elem.mediaOptions.id = elem.id
                 array.push(elem.mediaOptions)
                 count++;
                 if (count == refCount) {
                   resolve(array)
                 }
   
               }*/
          }
          else if (elem.type == 'web') {


            array.push(elem)
            count++;
            if (count == refCount) {
              resolve(array)
            }
          }

          if (elem.children != undefined && elem.children.length > 0) {
            getAllMediaToCopy(elem.children)
          }

          if (count == refCount)
            resolve(array)
        })


      }

      getAllMediaToCopy(arr)

    })
  }



  deleteAllMediaInArray(mediaArray, backupData, mediaOriginList = null) {
    console.log("DELETE ALL MEDIA IN ARRAY", mediaArray, backupData,)

    let mediaOrginListId = mediaOriginList.map(v => v.id);

    console.log(mediaOrginListId)
    return new Promise<any>((resolve, reject) => {



      let promiseArray = []

      let loopTrough = (tab) => {
        tab.forEach((elem) => {

          if (elem.children != undefined && elem.children.length > 0) {
            loopTrough(elem.children)
          }
          console.log("DELETE ELEMENT", elem)
          if (!mediaOrginListId.includes(elem.id))
            promiseArray.push(this.afs.collection('media').doc(elem.id).delete().then(d => {




              //console.log("ELEMENT TO DELETE", elem)
              let fileUrlArray: Array<any> = [];
              let eachRecursive = (obj) => {
                for (var k in obj) {
                  let url;

                  try {
                    url = new URL(obj[k]);
                  } catch (err) {
                  }

                  if (url && url.host == 'firebasestorage.googleapis.com')
                    fileUrlArray.push(obj[k])

                  if (typeof obj[k] == "object" && obj[k] !== null)
                    eachRecursive(obj[k]);
                  else { }
                }

              }

              eachRecursive(elem)

              fileUrlArray.forEach((item) => {
                this.checkIfTimeFileUsed(item).then(d => {
                  //console.log(d)
                  if (d <= 1 && backupData && !backupData.urlImageBackUpArray.includes(item)) {
                    //console.log('CAN DELETE ELEMENT', item)
                    this.storage.storage.refFromURL(item).delete();
                  }
                })
              })



            }).catch(err => {
              console.log("ERR", err)
            }));

        })
      }

      //   console.log(item)
      console.log("NEW MEDIA ARRAY", mediaArray)
      loopTrough(mediaArray)

      Promise.all(promiseArray).then(d => {
        resolve('OK')
      })
    })







  }


  updateMediaSettingsOfAllGroup(data, group, selectedName, backupData) {

    let mediaArray = [];



    //console.log("SELECTED NAME", selectedName)


    this.listAllDataFromFileTree(data.fileTree).then(d => {
      mediaArray = d;

      this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', 'media').where('group', '==', group).get().then(d => {
        let docs = d.docs.map(v => {
          return { id: v.id, data: v.data() }
        })
        docs.forEach((item: any) => {
          if (item.data.device != selectedName) {
            //  let oldData = JSON.parse(JSON.stringify(item.data.fileTree))


            /* DELETE OLD MEDIA*/


            if (data.logoUrl != undefined && (item.data.logoUrl != data.logoUrl))
              this.removeImg(item.data.logoUrl, backupData);

            if (data.rootBackgroundAsset != undefined && (item.data.rootBackgroundAsset != data.rootBackgroundAsset))
              this.removeImg(item.data.rootBackgroundAsset, backupData);


            let oldData = JSON.parse(JSON.stringify(item.data.fileTree))





            let newFileTree = JSON.parse(JSON.stringify(data.fileTree))
            let newItem = JSON.parse(JSON.stringify(item))

            /* CREATE NEW MEDIA */



            let promiseArray = [];

            let count;
            console.log("MEDIA ARRAY", mediaArray)
            mediaArray.forEach((media, index) => {



              if (media.type == "web") {
                /* CREATE NEW KIOSK  */

                this.afs.collection('media').doc(media.id).get().toPromise().then(mediaK => {




                  this.addKioskToDeviceModule(mediaK.data(), group, item.data.device)

                  promiseArray.push(this.generateNewMediaFromApplyAll(mediaK.data(), newFileTree).then(tmpfileTree => {
                    newFileTree = tmpfileTree
                    this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item);
                  }))

                })
              }

              else if (media.type == 'quiz') {
                promiseArray.push(this.addQuizToDeviceModule(media, group, item.data.device).then(d => {

                  media.idQuiz = d;

                  promiseArray.push(this.generateNewMediaFromApplyAll(media, newFileTree).then(tmpfileTree => {
                    newFileTree = tmpfileTree

                    this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item);
                  }))
                }))
              }
              else {
                promiseArray.push(this.generateNewMediaFromApplyAll(media, newFileTree).then(tmpfileTree => {
                  newFileTree = tmpfileTree
                  this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, null);
                }))
              }
              /* COPY NEW FILE */











              this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, null);


            })


            console.log("[updateMediaSettingsOfAllGroup] BEFORE DELETE MEDIA IN ARRAY ", data, group, selectedName, backupData)
            this.deleteAllMediaInArray(oldData, item.data.backup).then(() => {
            })
          }
        })
      }).catch(err => {
        console.log(err);
      })
    })

  }

  async setNewWebMediaElement() {

  }

  async updateMediaSettingsOfDevice(data, group, selectedName, backupData, listDevices) {

    let mediaArray = [];

    return new Promise<any>((resolve, reject) => {
      //console.log("SELECTED NAME", selectedName)


      this.listAllDataFromFileTree(data.fileTree).then(d => {

        console.log("MEDIA ARRAY", d);
        mediaArray = d;
        /*  console.log(listDevices)
          return*/


        listDevices.forEach(device => {
          this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', 'media').where('group', '==', group).where('device', '==', device.data.name).get().then(async (d) => {
            let docs = d.docs.map(v => {
              return { id: v.id, data: v.data() }
            })

            console.log(docs)


            for (const item of docs) {
              if (item.data.device != selectedName) {
                //  let oldData = JSON.parse(JSON.stringify(item.data.fileTree))


                // DELETE OLD MEDIA


                if (data.logoUrl != undefined && (item.data.logoUrl != data.logoUrl))
                  this.removeImg(item.data.logoUrl, backupData);

                if (data.rootBackgroundAsset != undefined && (item.data.rootBackgroundAsset != data.rootBackgroundAsset))
                  this.removeImg(item.data.rootBackgroundAsset, backupData);


                let oldData = JSON.parse(JSON.stringify(item.data.fileTree))





                let newFileTree = JSON.parse(JSON.stringify(data.fileTree))
                let newItem = JSON.parse(JSON.stringify(item))

                // CREATE NEW MEDIA 
                let promiseArray = [];
                let count;

                let generateFilePromise = [];
                console.log("NEW FILTETREE", newFileTree)



                //let newFileTreeSave = newFileTree
                for (const media of mediaArray) {


                  await this.manageFileGenerationPromise(media, group, item, newFileTree, promiseArray, data, newItem, device).then(d => {
                    console.log(d)
                    newFileTree = d;
                  })
                }

                //DEFAULT LOOP

                /*for (const media of mediaArray) {
                  console.log("MEDIA ARRAY LOOP THROUGH")
                  generateFilePromise.push(this.manageFileGenerationPromise(media, group, item, newFileTree, promiseArray, data, newItem, device).then(d => {
                    console.log(d)
                  }))
                }*/
                console.log("ALL GENERATED ?", newFileTree)

                await this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, device)

                console.log("PROMISE ARRAY STATE", promiseArray)
                //   Promise.all(generateFilePromise).then(() => {
                console.log("ALL GENERATION CONCLUDE", oldData, newFileTree)

                console.log("Check lastfolder of old filetree & new filetree")
                let lastOldFolder = oldData[oldData.length - 1];
                let lastFolderStillExist


                console.log(lastOldFolder)
                lastFolderStillExist = newFileTree.filter(v => v.type == lastOldFolder?.type && v.path == lastOldFolder?.path && v.displayName == lastOldFolder?.displayName)
                if (lastFolderStillExist.length > 0)
                  oldData.pop();


                console.log("[updateMediaSettingsOfDevice], BEFORE DELETE MEDIA IN ARRAY ", data, group, selectedName, backupData, listDevices)
                this.deleteAllMediaInArray(oldData, item.data.backup, mediaArray).then(() => {
                  resolve('END');
                })
                //  })

                //console.log(item)

              }


            }
          }).catch(err => {
            console.log(err);
          })
        })
        console.log(listDevices)
      })
    })


  }


  async manageFileGenerationPromise(media, group, item, newFileTree, promiseArray, data, newItem, device) {
    return new Promise<void>((resolve, reject) => {


      if (media.type == "web") {
        /* CREATE NEW KIOSK  */
        console.log("ADD NEW KIOSK")
        this.afs.collection('media').doc(media.id).get().toPromise().then(async (mediaK) => {
          console.log(mediaK.data(), group, item.data.device)

          if (mediaK.data()) {
            await this.addKioskToDeviceModule(mediaK.data(), group, item.data.device)

            promiseArray.push(this.generateNewMediaFromApplyAll(mediaK.data(), newFileTree).then(tmpfileTree => {

              newFileTree = tmpfileTree
              resolve(newFileTree);
              //    this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, device).then(() => resolve())
            }))
          }


        })
      }

      else if (media.type == 'quiz') {
        console.log("ADD NEW QUIZ")
        promiseArray.push(this.addQuizToDeviceModule(media, group, item.data.device).then(d => {

          media.idQuiz = d;
          if (media)
            promiseArray.push(this.generateNewMediaFromApplyAll(media, newFileTree).then(tmpfileTree => {
              newFileTree = tmpfileTree
              resolve(newFileTree);
              //   this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, device).then(() => resolve());
            }))
        }))
      }
      else if (media.type == 'lottery') {
        console.log("MEDIA LOTTERY", media)
        promiseArray.push(this.addLotteryToDeviceModule(media, group, item.data.device).then(d => {

          if (media)
            promiseArray.push(this.generateNewMediaFromApplyAll(media, newFileTree).then(tmpfileTree => {
              newFileTree = tmpfileTree
              resolve(newFileTree);
              //   this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, device).then(() => resolve());
            }))
        }))


      }
      else {
        console.log("ADD NEW OTHER ELEMENT")
        if (media) {
          promiseArray.push(this.generateNewMediaFromApplyAll(media, newFileTree, newItem).then(tmpfileTree => {
            newFileTree = tmpfileTree
            resolve(newFileTree);
            //      this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, device).then(() => resolve());
          }))
        }

      }
      /* COPY NEW FILE */
      //  this.generateNewFileTree(promiseArray, newItem, data, newFileTree, item, device).then(() => resolve());

    })
  }

  getFileTreeFromDevice(device) {
    return new Promise<any>((resolve, reject) => {

      this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('group', '==', device.group).where('device', '==', device.name).where('type', '==', 'media').get().then(d => {
        //  console.log('GET CURRENT DEVICE FILETREE', d.docs.map(v => v.data()));
        resolve(d.docs.map(v => v.data())[0].fileTree)
      })
    })

  }

  generateNewFileTree(promiseArray, newItem, data, newFileTreeData, item, device = null) {



    let newFileTree = JSON.parse(JSON.stringify(newFileTreeData))
    return new Promise<void>((resolve, reject) => {
      console.log(promiseArray)



      Promise.all(promiseArray).then(d => {

        /* CHECK IF NEED TO KEEP LAST FOLDER */
        if (/*this.user.uid == '96oXRJRiaBNX5fWzodHlXlBrnUr2' || */isDevMode() || this.user.role == 'mainuser') {

          console.log("KEEP LAST FOLDER FROM TARGET DEVICE", device)
          this.getFileTreeFromDevice(device.data).then(d => {
            console.log("TARGET DEVICE FILETREE", d)
            let targetFileTreeFolders = d.filter(v => v.type == 'folder')

            console.log(targetFileTreeFolders, JSON.parse(JSON.stringify(newFileTree)))
            let lastFolder = targetFileTreeFolders[targetFileTreeFolders.length - 1];



            console.log(newFileTree, lastFolder)



            let lastOrigineFolder = newFileTree[newFileTree.length - 1]

            let lastFolderStillExist: boolean = false;


            if (lastFolder && lastOrigineFolder.name == lastFolder.name &&
              lastOrigineFolder.type == lastFolder.type &&
              lastOrigineFolder.path == lastFolder.path &&
              lastOrigineFolder.displayName == lastFolder.displayName) {

              lastFolderStillExist = true;
              //   lastFolderStillExist = newFileTree.filter(v => v.name == lastFolder.name && v.type == lastFolder.type && v.path == lastFolder.path && v.displayName == lastFolder.displayName)
              /*    this.getMedia(lastFolder.id).then(m => {
                    console.log("LAST FOLDER MEDIA DATA", m)
                  })*/
            }

            if (lastFolder && lastFolderStillExist) {

              newFileTree.pop();
              newFileTree.push(lastFolder)

            }
            /*  else {
  
                if (lastFolder)
                  newFileTree.push(lastFolder)
              }*/



            newItem.data.mediaStyle = data.mediaStyle;

            if (data.rootBackgroundAsset != undefined)
              newItem.data.rootBackgroundAsset = data.rootBackgroundAsset;

            if (data.logoUrl != undefined)
              newItem.data.logoUrl = data.logoUrl;


            console.log(newItem.data)

            if (newFileTree)
              newItem.data.fileTree = this.cleanData(newFileTree)
            newItem.data.latestUpdate = new Date();




            //  console.log(newItem.data)

            //   alert("UPDATE DISABLED FOR DEVELOPMENT PURPOSE")

            //   console.log(item.id, newItem.data)
            this.afs.collection('modules').doc(item.id).update(newItem.data).then(() => resolve())

          })
        }
        /* APPLY NEW FILETREE */
        else {
          newItem.data.mediaStyle = data.mediaStyle;

          if (data.rootBackgroundAsset != undefined)
            newItem.data.rootBackgroundAsset = data.rootBackgroundAsset;

          if (data.logoUrl != undefined)
            newItem.data.logoUrl = data.logoUrl;

          newItem.data.fileTree = this.cleanData(newFileTree)
          newItem.data.latestUpdate = new Date();


          console.log(item.id, newItem.data)
          //  console.log(newItem.data)
          this.afs.collection('modules').doc(item.id).update(newItem.data).then(() => resolve())
        }



      })


    })

  }





  generateNewMediaFromApplyAll(media, newFileTree, newItem = null) {


    console.log(newItem)
    console.log(JSON.parse(JSON.stringify(newFileTree)))
    return new Promise<any>((resolve, reject) => {




      let mediaData = JSON.parse(JSON.stringify(media))

      delete mediaData.id
      console.log(media)
      this.afs.collection('media').add(mediaData).then(newMedia => {



        let loopThroughFileTreeAndCheck = (fileTreeElem) => {
          fileTreeElem.forEach(element => {
            console.log("CHECK MEDIA", element, media)

            if (element.mediaOptions != undefined /*&& !element.new && this.checkIfSameMediaElement(element.mediaOptions, media)*/) {


              if (element.id == media.id) {
                console.log(`ELEMENT FOUND, CHANGING ID FROM ${element.id} to ${newMedia.id}`)
                element.id = newMedia.id;

              }


              /*   if (!this.checkIfIdAlreadyExist(newMedia.id, newFileTree)) {
                   element.id = newMedia.id
                  // element.new = true;
                 }*/

            }
            else if (element.mediaOptions == undefined /*&& !element.new*/ && this.checkIfSameMediaElement(element, media)) {
              // if (!this.checkIfIdAlreadyExist(newMedia.id, newFileTree)) {
              if (element.id == media.id) {
                console.log(`ELEMENT FOUND, CHANGING ID FROM ${element.id} to ${newMedia.id}`)
                element.id = newMedia.id

              }

              // element.new = true
              //  }

              if (element.type == 'quiz') {

                element.idQuiz = media.idQuiz;
                // element.new = true
              }

            }





            if (element.children != undefined && element.children.length > 0)

              loopThroughFileTreeAndCheck(element.children)
          })

        }

        loopThroughFileTreeAndCheck(newFileTree)





        /*  let cleanInfos = (tab) => {
            tab.forEach(item => {
              if (item.new)
                delete item.new
  
              if (item.children)
                cleanInfos(item.children)
  
            })
          }*/
        //  cleanInfos(newFileTree)
        console.log(newFileTree)
        resolve(newFileTree)
      })
    })
  }

  checkIfIdAlreadyExist(id, fileTree): boolean {
    let exist = false;

    let loopThrough = (tab) => {
      tab.forEach(item => {

        console.log(item.id, id)
        if (item.id == id)
          exist = true;

        if (item.children)
          loopThrough(item.children);
      })

    }


    console.log("CHECK IF ID IS ALREADY IN FILETREE", fileTree, Array.isArray(fileTree))
    if (Array.isArray(fileTree))
      loopThrough(fileTree)


    console.log(exist)
    return exist


  }


  checkIfSameMediaElement(fileTreeElement, media) {
    let isSame: boolean = false;
    if (fileTreeElement.name == 'Vidéos' && media.name == 'Vidéos')
      console.log("CHECK IF SAME ELEMENT", fileTreeElement, media)
    if (fileTreeElement.type == media.type && fileTreeElement.name == media.name && fileTreeElement.path == media.path /*&& fileTreeElement.firestoragePath == media.firestoragePath*/) {
      // if (fileTreeElement.type == 'folder')
      isSame = true;
    }
    return isSame;

  }
  updateKioskSettingsOfAllGroup(data, group, selectedName) {

    this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', 'kiosk').where('group', '==', group).get().then(d => {
      let docs = d.docs.map(v => {
        return { id: v.id, data: v.data() }
      })




      docs.forEach((item: any) => {
        if (item.data.device != selectedName) {
          item.data.urlConfig.forEach(elem => {


            if (elem.thumbnailUrl) {
              this.removeImg(elem.thumbnailUrl);
            }


          })

          this.afs.collection('modules').doc(item.id).update({ urlConfig: data.urlConfig, urlLock: data.urlLock })




        }
      })


    }).catch(err => {
      console.log(err)
    })

  }


  copyQuiz(questionsToCopy, deviceName, idModule, listQuiz, activeQuiz) {

    /* CREATE NEW QUIZ */
    listQuiz.data.forEach((dataElement, index) => {


      let tmp = dataElement;



      tmp.device = deviceName
      tmp.idModule = idModule

      this.afs.collection('quiz').add(tmp).then(newQuiz => {


        if (listQuiz.id[index] == activeQuiz) {
          this.afs.collection('modules').doc(idModule).update({ activeQuiz: newQuiz.id })
        }
        questionsToCopy.forEach((newQuestion) => {
          let tmpNewQuestion = newQuestion.data



          tmpNewQuestion.device = deviceName
          tmpNewQuestion.idQuiz = newQuiz.id;


          this.afs.collection('questions').add(tmpNewQuestion).then(nQu => {
          })


        })



      })
    })

  }




  updateQuizSettingsOfAllGroup(data, group, selectedDevice, idModule, moduleData) {

    let questionsToCopy = [];

    let promiseList = [];
    let deviceToChangeList: any = [];

    /*GET LIST OF QUESTION TO COPY*/
    data.id.forEach(quizId => {
      this.afs.collection('questions').ref.where('parent', '==', this.user.uid).where('idQuiz', '==', quizId).get().then(d => {
        let questions = d.docs.map(v => {
          return { id: v.id, data: v.data() }

        })



        questionsToCopy = questionsToCopy.concat(questions)
      })
    })

    this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', 'quiz').where('group', '==', group).get().then(d => {
      let docs = d.docs.map(v => {
        return { id: v.id, data: v.data() }
      })

      docs.forEach((item: any) => {

        /** DELETE OLD QUIZ AND QUESTIONS  **/
        if (item.data.device != selectedDevice) {

          deviceToChangeList.push(item);







          promiseList.push(this.afs.collection('quiz').ref.where('parent', '==', this.user.uid).where('idModule', '==', item.id).get().then(e => {
            let quiz = e.docs.map(v => {
              return { id: v.id, data: v.data() }
            })

            if (quiz.length == 0) {

            }


            quiz.forEach((elem) => {



              promiseList.push(this.afs.collection('questions').ref.where('parent', '==', this.user.uid).where('idQuiz', '==', elem.id).get().then(f => {
                let questions = f.docs.map(v => {
                  return { id: v.id, data: v.data() }
                })



                /* DELETE ALL MEDIA FROM QUESTIONS */
                questions.forEach((media: any) => {
                  if (media.data.urlMedia)

                    this.removeImg(media.data.urlMedia)



                  promiseList.push(this.afs.collection('questions').doc(media.id).delete());


                })



              }))

              this.afs.collection('quiz').doc(elem.id).delete();

            })


          }))








        }








      })


      Promise.all(promiseList).then(a => {
        deviceToChangeList.forEach((item) => {

          this.copyQuiz(questionsToCopy, item.data.device, item.id, data, moduleData.activeQuiz)


          if (!moduleData.enableRules) {
            moduleData.enableRules = false;
            moduleData.rulesURL = "";
          }





          this.afs.collection('modules').doc(item.id).update({ rulesDisplay: moduleData.enableRules, urlRules: moduleData.rulesURL })
          promiseList = [];

        })

      })





    }).catch(err => {
      console.log(err)
    })


  }

  /**
   * Update the 'config' key for all the module from a group
   * @param module The module's type
   * @param group The module's group
   * @param device The module's device
   * @param config The config data
   */
  updateModuleOfAllGroup(module, group, device, config) {


    this.afs.collection('modules').ref.where('parent', '==', this.user.uid).where('type', '==', module).where('group', '==', group).get().then(d => {

      d.docs.forEach((doc: any) => {
        if (doc.data().device != device) {


          this.afs.collection('modules').doc(doc.id).update({ config: config })

        }
      })
    })
  }


  /**
   * Delete the group in Firestore
   * @param group The group's name
   */
  deleteGroup(group, id) {



    this.afs.collection('devices').ref.where('parent', '==', id).where('group', '==', group).get().then(d => {
      d.docs.map(v => v.ref.delete());
    })

    this.afs.collection('groups').ref.where('parent', '==', id).where('name', '==', group).get().then(d => {
      d.docs.map(v => v.ref.delete());
    })

    this.afs.collection('data').ref.where('parent', '==', id).where('group', '==', group).get().then(d => {
      d.docs.map(v => v.ref.delete());
    })

    this.afs.collection('modules').ref.where('parent', '==', id).where('group', '==', group).get().then(d => {
      d.docs.map(v => v.ref.delete());
    })

  }


  /**
   * Delete the deivce in Firestore
   * @param device The device's name
   */
  deleteDevice(device) {

    let data = device.data
    this.afs.collection('data').ref.where('parent', '==', data.parent).where('group', '==', data.group).where('device', '==', data.name).get().then(d => {
      d.docs.map(v => v.ref.delete());
    })

    this.afs.collection('modules').ref.where('parent', '==', data.parent).where('group', '==', data.group).where('device', '==', data.name).get().then(d => {
      d.docs.map(v => v.ref.delete());
    })


    this.afs.collection('devices').ref.where('parent', '==', data.parent).where('group', '==', data.group).where('name', '==', data.name).get().then(d => {
      d.docs.map(v => v.ref.delete());
    })
  }



  /**
   * Remove user in Firestore and FireAuth
   * @param uid The user's uid
   */
  deleteUser(uid) {

    /*  return new Promise<any>((resolve, reject) => {
        const callable = this.afFunc.httpsCallable('deleteuser')
        let data = callable({ uid: uid }).toPromise().then(d => {
          console.log(d);
          resolve(d)
        })
      })*/
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'PTXSHVM2lD5eP4JOXoLJuIKHbTHpyIYp',

    })

    return new Promise((resolve, reject) => {
      this.http.post(this.adminFirebaseUrl + '/deleteuser', { uid: uid }, { headers: header }).subscribe((data: any) => {
        if (data.message == 'OK') {

          this.afs.doc(`users/${uid}`).delete().then(() => resolve('OK')).catch(err => reject(err));
        }
        else
          reject(data.message)
      })
    })
  }

  copyFile(bucket, oldfilename, newfilename) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'PTXSHVM2lD5eP4JOXoLJuIKHbTHpyIYp',

    })

    return new Promise((resolve, reject) => {
      this.http.post(this.adminFirebaseUrl + '/copyFile', { bucket: bucket, oldfilename: oldfilename, newfilename: newfilename }, { headers: header }).subscribe((data: any) => {
        if (data.message == 'OK') {
        }
        else
          reject(data.message)
      })
    })
  }

  /**
   * Logout from Firebase
   * */
  logout() {

    this.presence.signOut();
    this.user = { uid: null, role: null, email: null, createdAt: null };
    this.afAuth.auth.signOut();


    this.router.navigate(['/login'])
    window.location.reload();
  }

  async logIn(email, password) {
    return new Promise((resolve, reject) => {
      this.afAuth.auth.signInWithEmailAndPassword(email, password).then(auth => {
        let userId = auth.user.uid;
        resolve("OK")
        this.afs.doc(`users/${userId}`).get().subscribe((doc) => {
          if (doc.exists) {
            //console.log("CHECK LOGIN")
            this.setLocalUser(doc.data());
            if (this.user.role == 'home')
              this.router.navigate(['/'])
            else if (this.user.role == 'admin')
              this.router.navigate(['/admin'])
          }

          else {
          }
        })
      }).catch((err) => {
        reject(err)

      })
    });


  }


  /**
   * Return module data from user uid and type
   * @param uid user uid
   * @param type module type
   */

  getModuleDataFromUserAndType(uid, type) {

    return this.afs.collection('modules').ref.where('parent', '==', uid).where('type', '==', type).get();
  }

  /**
   * Return snapshot from data
   * @param device The device's name
   * @param group The group's name
   */
  getModuleData(device, group, deviceId = null) {

    /* CHECK DATA FROM DEVICE DATA */
    this.afs.collection('data').ref.where('parent', '==', this.user.uid).where('deviceId', '==', deviceId).onSnapshot(docSnapshot => {
      let data: any = docSnapshot.docs.map(v => v.data());
      let id: any = docSnapshot.docs.map(v => v.id);


      console.log(data, id)

      if (data.length > 0)
        this.dataModuleValues.next({ id: id, data: data })
      else
        // CHECK DATA FROM USER, GROUP AND DEVICE
        this.afs.collection('data').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).onSnapshot(docSnapshot => {
          let dataOG: any = docSnapshot.docs.map(v => v.data());
          let idOG: any = docSnapshot.docs.map(v => v.id);


          // if (dataOG.length > 0)
          this.dataModuleValues.next({ id: idOG, data: dataOG })


        })


    })


  }



  /**
   * 
   * @param uid UID User
   */

  getAllDataFromUser(uid) {
    return this.afs.collection('data').ref.where('parent', '==', uid).get();
  }



  cleanModuleSnapshot() {
    try {
      this.moduleSnapshot()

    }
    catch (err) {
      console.log(err)
    }
    //  this.moduleSnapshot.unsubscribe();
  }

  /**
  * Return snapshot from module
  * @param device The device's name
  * @param group The group's name
  * @param type The module's type
  */
  getModuleSnapshot(type, group, device) {

    return new Promise<any>((resolve, reject) => {
      this.moduleSnapshot = this.afs.collection('modules').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).where('type', '==', type).onSnapshot(docSnapshot => {

        let data: any = docSnapshot.docs.map(v => v.data());
        let id: any = docSnapshot.docs.map(v => v.id);

        this.mediaModuleSnapshot?.next({ id: id[0], data: data[0] })
        resolve({ id: id[0], data: data[0] })
      })
    })

  }


  mergeTypedArrays(a, b) {
    // Checks for truthy values on both arrays 
    if (!a && !b) throw 'Please specify valid arguments for parameters a and b.';

    // Checks for truthy values or empty arrays on each argument 
    // to avoid the unnecessary construction of a new array and 
    // the type comparison 
    if (!b || b.length === 0) return a;
    if (!a || a.length === 0) return b;

    // Make sure that both typed arrays are of the same type 
    if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b))
      throw 'The types of the two arguments passed for parameters a and b do not match.';

    var c = new a.constructor(a.length + b.length);
    c.set(a);
    c.set(b, a.length);

    return c;
  }

  generateNewMP3Files(item, filename) {

    return new Promise<any>((resolve, reject) => {
      let path = `users/${this.user.displayName}/sound/${filename}`


      this.storage.ref(item.ref).getDownloadURL().toPromise().then(d => {
        let fileArray = new Uint8Array()
        fetch(d).then(htmlReturn => {
          const reader = htmlReturn.body.getReader();
          let that = this;

          // console.log(reader)
          reader
            .read()
            .then(function appendStreamChunk({ done, value }) {
              //If the reader doesn't return "done = true" append the chunk that was returned to us
              // rinse and repeat until it is done.
              if (value) {
                fileArray = that.mergeTypedArrays(fileArray, value)
              }
              if (done) {
                //  console.log(fileArray)
                return fileArray
              } else {
                // "Readout not complete, reading next chunk"
                return reader.read().then(appendStreamChunk)
              }
            })
            .then(file => {
              //Write the file to the new storage place
              //   console.log(user)

              let status = this.storage.upload(path, file).then(() => {
                this.storage.ref(path).getDownloadURL().toPromise().then(d => {
                  //console.log("MOVE ELEMENT SOUND", d)

                  resolve({
                    enable: false, data: { name: filename, url: d }
                  })
                  //   soundConfig[item.type] = 
                  //  soundConfig.push({`${item}`: { enable: false, data: { name: `${uuidv4()}.mp3`, url: null } })
                })

                /* this.firebaseService.getModuleDataFromUserAndType(user.uid, 'lottery').then(lotConf => {
                   console.log(lotConf.docs.map(v => v.data()))
                 })*/

                //   let soundData =
                /*  this.firebaseService.getModuleFromDevice('lottery', groupName, borneName).then(a => {
                    console.log(a)
                  })*/
              })


            })
        })
      })
    })

  }

  deleteLotteryFiles(config) {

    /* Delete Sound files */
    let soundData = config.data.sound
    let soundKeys = Object.keys(config.data.sound)

    soundKeys.forEach(item => {

      //console.log(item)
      if (soundData[item] != null && soundData[item].data.url)
        this.deleteFileFromUrl(soundData[item].data.url);
    })

  }

  generateLotteryNewAudioFile() {
    let soundType = [{ ref: 'ambiance_default.mp3', type: 'loop' }, { ref: 'win_default.mp3', type: 'win' }, { ref: 'loose_default.mp3', type: 'lose' }]

    return new Promise<any>((resolve, reject) => {

      let soundConfig = { loop: null, win: null, lose: null };

      soundConfig.loop = {}

      let fileCopiedPromise = [];
      soundType.forEach((item, index) => {
        fileCopiedPromise.push(this.generateNewMP3Files(item, `${uuidv4()}.mp3`).then(d => {
          soundConfig[item.type] = d;
        }))
      })
      Promise.all(fileCopiedPromise).then(d => {

        resolve(soundConfig)
        //    console.log("ALL FILE MOVED", soundConfig)
      })

      //  soundConfig.push({`${item}`: { enable: false, data: { name: `${uuidv4()}.mp3`, url: null } })
    })

  }

  async deleteLotteryData(device, group, module, lotteryName) {
    return new Promise<any>((resolve, reject) => {

      if (lotteryName)
        this.afs.collection('data').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid)
          .where('module', '==', module).where('lotteryName', '==', lotteryName).get().then(d => {
            let docs = d.docs.map(v => v.ref);

            let arrayPromise = [];
            //console.log(docs)
            /* docs.forEach((item) => {
               arrayPromise.push(await item.delete())
             })*/





            Promise.all(docs.map(async (doc) => {
              await doc.delete();
            })).then(d => {
              console.log("All Docs deleted")
              resolve("OK")
            })
          }).catch(err => {
            reject(err)
          })



      else
        this.deleteData(device, group, module).then(() => {
          resolve('OK')
        }).catch(err => {
          reject(err);
        })



    })
  }


  /**
   * Delete data in Firestore '/data' collection
   * @param device The device's name
   * @param group The group's name
   * @param module The module's name
   */
  async deleteData(device, group, module) {

    return new Promise<any>((resolve, reject) => {
      this.afs.collection('data').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).where('module', '==', module).get().then(d => {
        let docs = d.docs.map(v => v.ref);

        let arrayPromise = [];
        //console.log(docs)
        /* docs.forEach((item) => {
           arrayPromise.push(await item.delete())
         })*/





        Promise.all(docs.map(async (doc) => {
          await doc.delete();
        })).then(d => {
          console.log("All Docs deleted")
          resolve("OK")
        })
      }).catch(err => {
        reject(err)
      })
    })

  }


  deleteQuizData(device, group, module, quizId) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('data').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).where('module', '==', module).where('quiz', '==', quizId).get().then(d => {
        let docs = d.docs.map(v => {

          return { ref: v.ref, data: v.data(), id: v.id }
        });
        let arrayPromise = [];


        const isValidUrl = (string) => {

          try {
            new URL(string);
            return true;
          } catch (e) {
            return false;
          }

        }
        /* const isValidUrl = urlString => {
           var urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
             '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
             '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
             '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
             '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
             '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
           return !!urlPattern.test(urlString);
         }*/


        docs.forEach((item) => {
          item.data.data.map(v => {
            if (isValidUrl(v.value))
              this.deleteFileFromUrl(v.value)
            console.log("MUST DELETE FILE", v.value, isValidUrl(v.value))
          })
          //      console.log(item.data)
          arrayPromise.push(item.ref.delete())
        })
        Promise.all(arrayPromise).then(d => {
          resolve("OK")
        })
      }).catch(err => {
        reject(err)
      })
    })
  }


  /**
   * Delete quiz and linked question
   * @param quizId The quiz's id
   */
  deleteQuiz(quizId) {
    this.afs.collection('questions').ref.where('idQuiz', '==', quizId).get().then(data => {
      data.docs.map(v => v.ref.delete())
    })

    this.afs.collection('quiz').doc(quizId).delete();
  }


  /* updateListBackgrounds(url, type) {
     this.afs.collection('devices').ref.where('parent', '==', this.user.uid).get().then(d => {
       if(type == 'remove')
       d.docs.map(v => {
   
         v.data().config.listBackgrounds.splice(v.data().config.listBackgrounds.indexOf(url), 1);
       })
     })
   }*/

  private unsubscribeQuestionsSnapshot: (() => void) | null = null;

  /**
   * Return snapshot on all the questions from a quiz
   * @param quizId The quiz's id
   */
getQuestionFromQuiz(quizId) {
    return new Promise<any>((resolve, reject) => {
      // Kill any previous listener before attaching a new one
      if (this.unsubscribeQuestionsSnapshot) {
        this.unsubscribeQuestionsSnapshot();
        this.unsubscribeQuestionsSnapshot = null;
      }

      let resolved = false;

      this.unsubscribeQuestionsSnapshot = this.afs.collection('questions').ref
        .orderBy('priority', 'asc')
        .where('idQuiz', '==', quizId)
        .onSnapshot(docSnapshot => {
          const data: any = docSnapshot.docs.map(v => v.data());
          const id: any = docSnapshot.docs.map(v => v.id);

          if (data != undefined) {
            this.questionsData.next({ id, data, snapshot: docSnapshot });
            if (!resolved) {
              resolved = true;
              resolve({ id, data, snapshot: docSnapshot });
            }
          } else if (!resolved) {
            resolved = true;
            reject();
          }
        });
    });
  }


  /**
   * Return snapshot of a quiz
   * @param group The group's name
   * @param device The device's name
   * @param idModule The module's id
   */
  getQuizFromDevice(group, device, idModule) {
    return new Promise<void>((resolve, reject) => {
      this.afs.collection('quiz').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).where('idModule', '==', idModule).onSnapshot(docSnapshot => {

        if (docSnapshot == undefined)
          reject();
        else {
          let data: any = docSnapshot.docs.map(v => v.data());
          let id: any = docSnapshot.docs.map(v => v.id);
          this.quizModule.next({ id: id, data: data })
          resolve();
        }

      })
    })


  }

  /**
  * Return all quiz from device and group in a Promise
  * @param device The device's name
  * @param group The group's name
  */

  getAllQuizFromDevice(group, device) {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('quiz').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).get().then((d) => {

        let res = d.docs.map((v) => { return { id: v.id, data: v.data() } })

        resolve(res)
      }).catch(e => reject(e))
    })
  }


  duplicateQuiz(baseIdQuiz: string, baseDataQuiz: any, questionArray: any) {
    console.log(baseIdQuiz, baseDataQuiz, questionArray)

    baseDataQuiz.baseQuiz = baseIdQuiz;
    baseDataQuiz.name = `${baseDataQuiz.name} - Copie`
    this.afs.collection('quiz').add(baseDataQuiz).then(d => {
      console.log(d.id);


      questionArray.data.forEach((question, index) => {

        question.idQuiz = d.id;
        question.baseQuestionId = questionArray.id[index];
        this.afs.collection('questions').add(question).then(q => {
          console.log(q.id)
        });
      })

    })
  }


  /**
   * Create new quiz in Firestore
   * @param name The quiz's name
   * @param device The device's name
   * @param group The group's name
   * @param idModule The module's id
   */

  addQuiz(name, device, group, idModule) {
    return this.afs.collection('quiz').add({
      name: name, idModule: idModule, group: group, device: device, parent: this.user.uid, startText: 'Le questionnaire va démarrer !', endText: 'Merci d\'avoir participé !', colorBackground: '#94d4c0', colorText: '#ffffff', colorButton: '#ff6e2b'
    });
  }

  /**
   * Update the quiz's data
   * @param id The quiz's id
   * @param data The new data
   */

  updateActiveQuiz(id, data) {
    data.latestUpdate = new Date();
    this.afs.collection('quiz').doc(id).update(data).then(d => {
    }).catch(err => {
      console.log(err)
    })
  }

  /**
   * Return a promise with the quiz
   * @param id The quiz's id
   */
  getQuizData(id) {
    return this.afs.collection('quiz').doc(id).get().toPromise()
  }


  /**
   * Create a new question
   * @param data The question's data
   * @param group The group's name
   * @param device The device's name
   */
  addQuestion(data, group, device) {
    this.afs.collection('questions').add({ label: data.label, type: data.type, validation: data.validation, required: data.required, idQuiz: data.idQuiz, multi: data.multi, response: data.response, group: group, device: device, parent: this.user.uid, priority: data.priority });
  }

  getAllUrls(obj) {
    const urls = [];

    function traverse(value) {
      if (Array.isArray(value)) {
        for (const item of value) {
          traverse(item);
        }
      } else if (value && typeof value === 'object') {
        for (const key in value) {
          traverse(value[key]);
        }
      } else if (typeof value === 'string') {
        // Simple URL check; you can improve this regex if needed
        if (/^https?:\/\/\S+/.test(value)) {
          urls.push(value);
        }
      }
    }

    traverse(obj);
    return urls;
  }

  /**
   * Delete the question in Firestore
   * @param id The question's id
   */
  deleteQuestion(id) {
    return this.afs.collection('questions').doc(id).get().toPromise().then(d => {
      if (d.data().baseQuestionId) {
        /* CHECK IF MAIN QUESTION HAS SAME URL */
        let questionFiles = this.getAllUrls(d.data())
        this.afs.collection('questions').doc(d.data().baseQuestionId).get().toPromise().then(q => {
          let baseQuestionFiles = this.getAllUrls(q.data());
          questionFiles.map(v => {
            if (!baseQuestionFiles.includes(v))
              this.removeFileFromUrl(v);
          })
          d.ref.delete();
        })
      } else {
        d.ref.delete();
      }
    });
  }

  /**
  * Delete stats from device
  * @param userId The user's id
  * @param deviceName The device name
  */
  async deleteAllDeviceStats(deviceId) {
    await this.afs.collection('stats').doc(deviceId).ref.get().then(async (d) => {
      await d.ref.collection('mediaData').get().then(data => {
        data.docs.map(w => w.ref.delete())
      })

      console.log("DELETE MEDIA DATA")
      await d.ref.collection('sessionData').get().then(data => {
        data.docs.map(w => w.ref.delete())
      })
      console.log("DELETE SESSION DATA")

      // return;
      return d.ref.delete();
      /*  d.docs.map(v => {
  
          //REMOVE MEDIA DATA
          v.ref.collection('mediaData').get().then(data => {
            data.docs.map(w => w.ref.delete())
          })
  
          //REMOVE SESSION DATA
          v.ref.collection('sessionData').get().then(data => {
            data.docs.map(w => w.ref.delete())
          })
  
  
  
        })*/
    })

  }


  /**
   * Update the question
   * @param id The question's id
   * @param data The new data
   */
  updateQuestion(id, data) {
    this.afs.collection('questions').doc(id).update(data)
  }

  updateQuiz(id, data) {
    this.afs.collection('quiz').doc(id).update(data);
  }


  getMetadataFromUrl(url) {

    return new Promise<any>((resolve, reject) => {

      this.storage.storage.refFromURL(url).getMetadata().then(d => {
        resolve(d)
      }).catch(err => {
        reject(err);
      })
    })


  }




  sendUpdateToMedia(group, device) {
    this.afs.collection('modules').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).where('type', '==', 'media').get().then(d => {
      let doc = d.docs.map(v => {
        return { id: v.id, data: v.data() }
      })

      this.afs.collection('modules').doc(doc[0].id).update({ latestUpdate: new Date })
    })
  }


  removeLogo(url, group, device) {

    return new Promise((resolve, reject) => {
      if (url != undefined)
        this.checkIfTimeFileUsed(url).then(d => {

          if (d <= 1) {
            this.storage.storage.refFromURL(url).delete().then(d => {
              this.afs.collection('modules').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).where('type', '==', 'media').get().then(d => {
                let doc = d.docs.map(v => {
                  return { id: v.id, data: v.data() }
                })

                this.afs.collection('modules').doc(doc[0].id).update({ logoUrl: null }).then((d) => {
                  resolve('OK')
                }).catch(err => {
                  reject(err);
                })
              }).catch(err => {
                reject(err);
              })
            })
          }
          else {
            this.afs.collection('modules').ref.where('group', '==', group).where('device', '==', device).where('parent', '==', this.user.uid).where('type', '==', 'media').get().then(d => {
              let doc = d.docs.map(v => {
                return { id: v.id, data: v.data() }
              })

              this.afs.collection('modules').doc(doc[0].id).update({ logoUrl: null }).then((d) => {
                resolve('OK')
              }).catch(err => {
                reject(err);
              })
            }).catch(err => {
              reject(err);
            })
          }
        })



    })




  }


  updateUserEmail(oldEmail, newEmail, password) {


    let tmp = null;

    firebase.apps.forEach((item) => {
      if (item.name == 'auth-worker')
        tmp = item;
    })

    if (tmp == null)
      tmp = firebase.initializeApp(environment.firebaseConfig, 'auth-worker');

    tmp.auth().signInWithEmailAndPassword(oldEmail, password)
      .then(function (userCredential) {
        userCredential.user.updateEmail(newEmail)
      })

    this.afs.collection('users').ref.where('email', '==', oldEmail).get().then(d => {
      let id = d.docs.map(v => v.id)[0]


      this.afs.collection('users').doc(id).update({ email: newEmail })
    })
  }



  /**
   * Update the module
   * @param id The module's id
   * @param data The new data
   */
  updateModule(id, data) {



    return this.afs.collection('modules').doc(id).update(data)
  }


  deleteThumbnailFileFromUrl(url) {
    this.checkIfTimeFileUsed(url).then(d => {
      console.log("DELETE THUMBNAIL CHECK IF ALREADY USED", d)
      if (d <= 1) {
        this.storage.storage.refFromURL(url).delete();
      }

    })



  }

  deleteFileFromUrl(url) {

    this.storage.storage.refFromURL(url).delete();
  }


  getDeviceStat(deviceName): Promise<any> {
    return this.afs.collection('stats').ref.where('parent', '==', this.user.uid).where('deviceName', '==', deviceName).get()
  }

  updateDeviceStatsData(id: string, data: any) {
    return this.afs.collection('stats').doc(id).update(data);
  }


  getDeviceSessionStat(id, start: Date = null, end: Date = null): Promise<any> {
    if (start == null && end == null)
      return this.afs.collection('stats').doc(id).collection('sessionData').ref.get();//.toPromise();
    else
      return this.afs.collection('stats').doc(id).collection('sessionData').ref.where('date', '>', start).where('date', '<', end).get();
  }

  getDeviceMediaStat(id, start: Date = null, end: Date = null): Promise<any> {
    //console.log(id)
    if (start == null && end == null)
      return this.afs.collection('stats').doc(id).collection('mediaData').ref.get();
    else
      return this.afs.collection('stats').doc(id).collection('mediaData').ref.where('date', '>', start).where('date', '<', end).get();
  }

  getDeviceStatFromUser() {
    return this.afs.collection('stats').ref.where('parent', '==', this.user.uid).get();
  }

  checkIfDocExist(id) {
    return this.afs.collection('media').doc(id).get().toPromise();
  }

  async getPrintHistoryCounts(docId: string) {
    const doc = await this.afs.doc(`deviceStatus/${docId}`).get().toPromise();
    const data: any = doc.data();
    return {
      total: data?.printHistoryTotal || 0,
      okCount: data?.printHistoryOk || 0,
      notOkCount: data?.printHistoryNotOk || 0,
    };
  }


  getDevicesStatus() {
    return this.afs.collection(`deviceStatus`).ref.where('userId', '==', this.user.uid)
  }

  async getDeviceInformations(deviceId:string) {

    return await this.afs.collection('identificationDevice').ref.where('deviceId', '==', deviceId).where('uid', '==', this.user.uid).limit(1).get()
  }

  async editDeviceName(name: string, docId:string) {
    return await this.afs.doc(`identificationDevice/${docId}`).update({
      borneName:name
    })
  }

  async getHistoryFromDeviceId(docId:string) {
    return await this.afs.collection(`deviceStatus/${docId}/history`).ref.orderBy('timestamp', 'desc').limit(100).get();
  }
}
